import { forwardRef } from 'react';

import { useDialogComboboxContext } from '../../design-system/DialogCombobox/hooks/useDialogComboboxContext';
import type { DialogComboboxOptionListSelectItemProps } from '../DialogCombobox';
import { DialogComboboxOptionListSelectItem } from '../DialogCombobox';

export interface SelectV2OptionProps extends DialogComboboxOptionListSelectItemProps {}

export const SelectV2Option = forwardRef<HTMLDivElement, SelectV2OptionProps>((props, ref) => {
  const { value } = useDialogComboboxContext();
  return <DialogComboboxOptionListSelectItem checked={value && value[0] === props.value} {...props} ref={ref} />;
});
